<div class="otp-page">
  <div class="otp-container">
    <div class="otp-card">
      <!-- Logo -->
      <div class="logo">
        <a *ngIf="shared.domainType == 'physio'">
          <img src="assets/media/logos/plus_physio_Logo.png" alt="+Physio" />
        </a>
        <a *ngIf="shared.domainType == 'doctor'">
          <img src="assets/media/logos/PlusDoctorLogo.png" alt="+Doctor" />
        </a>
        <a *ngIf="shared.domainType == 'radiology'">
          <img src="assets/media/logos/Plus-Radiology.png" alt="+Radiology" />
        </a>
      </div>

      <!-- Title -->
      <h2 class="otp-title" *ngIf="isTwoFactorAuth">Two Step Verification</h2>
      <h2 class="otp-title" *ngIf="!isTwoFactorAuth">OTP Verification</h2>
      <p class="otp-subtitle">Enter the OTP sent to your email</p>

      <div class="otp-phone">{{email}}</div>

      <!-- OTP Input Boxes -->
      <form [formGroup]="OtpVerificationForm" (ngSubmit)="submit(OtpVerificationForm)" class="otp-form">
        <div class="otp-boxes">
          <input *ngFor="let box of otpControls; let i = index" type="text" maxlength="1" class="otp-input"
            [id]="'otp-' + i" (input)="onInput($event, i)" (keydown)="onKeyDown($event, i)" autocomplete="off"
            (paste)="onPaste($event)" />
        </div>

        <div class="resend-section">
          <button type="button" class="resend-btn" [disabled]="isResendDisabled || loadingResend" (click)="resendOTP()">
            Resend OTP
          </button>
          <span *ngIf="isResendDisabled" class="timer-text">in {{ formatTime(resendTimer) }}</span>
        </div>

        <button (click)="submit(OtpVerificationForm)" id="kt_login_signin_submit" [class.spinner]="loadingSubmit"
          class="btn btn-primary btn-elevate kt-login__btn-primary ml-2 verify-btn"
          [disabled]="!OtpVerificationForm.valid || loadingSubmit">
          Verify
        </button>
      </form>
    </div>

  </div>
  <!-- Footer -->
  <div class="emailFooter">
    <div class="footer">
      <div class="kt-footer kt-footer--extended kt-grid__item" id="kt_footer">
        <div class="kt-footer__bottom">
          <div class="kt-container">
            <div class="kt-footer__wrapper">
              <div class="kt-footer__logo" style="display: flex;">
                <a *ngIf="shared.domainType == 'physio'" href="javascript:;" routerLink="/Appointments">
                  <img alt="logo" src="assets/media/logos/plus_physio_Logo.png" class="kt-header__brand-logo-default"
                    style="width: 64px;" />
                </a>
                <a *ngIf="shared.domainType == 'doctor'" href="javascript:;" routerLink="/Appointments">
                  <img alt="logo" src="assets/media/logos/PlusDoctorLogo.png" class="kt-header__brand-logo-default"
                    style="width: 64px;" />
                </a>
                <a *ngIf="shared.domainType == 'radiology'" href="javascript:;" routerLink="/Appointments">
                  <img alt="logo" src="assets/media/logos/Plus-Radiology.png" class="kt-header__brand-logo-default"
                    style="width: 64px;" /></a>
                <div [ngStyle]="{'margin-top': '27px'}">
                  <span class="ft_position">{{currentApplicationVersion}}</span>
                </div>
              </div>
              <div class="kt-footer__menu">
                <div class="kt-footer__copyright ml-3">
                  Copyright © {{ today | date : "yyyy" }} iFour Technolab Pvt. Ltd. All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>